// extracted by mini-css-extract-plugin
module.exports =  {"button":"a10a3f92e9--button--gs5R_","loading":"a10a3f92e9--loading--fC43r","spinner":"a10a3f92e9--spinner--rWSqM"};